<icc-list [searchable]="true" [items]="drives"
          [itemTemplate]="'itemImgTitleDescription'"
          itemImgHeight="medium"
          (select)="selectDrive($event)"></icc-list>
